import { useSelector } from 'react-redux';

import { Menu } from 'antd';
import { RibbonButton } from 'common/components';
import { Can } from 'context/Can';
import { useGetProductFullView } from 'hooks';

import { ShopOutlined, DeploymentUnitOutlined } from '@ant-design/icons';

import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import {
  useCheckDisablePostProductTo,
  useCheckDisablePostProductToWalmart,
} from './utils';
import selectorsGridView from 'common/components/grid-view/controllers/selectors';

const { SubMenu } = Menu;

const PostToRibbonSection = ({
  isFullView = false,
  productId = null,
  togglePostToModal,
}) => {
  const { productFull } = useGetProductFullView({ productId });

  const selectProductGrid = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const selectedProducts = isFullView ? [productFull] : selectProductGrid;

  const disabledPostProductTo = useCheckDisablePostProductTo({
    selectedProducts,
  });

  const disabledPostToWalmart = useCheckDisablePostProductToWalmart({
    selectedProducts,
  });

  return (
    <>
      <SubMenu
        key={'post-product-to'}
        style={{ backgroundColor: 'inherit' }}
        title={
          <RibbonButton
            size='small'
            className='button-item-dropdown'
            icon={<DeploymentUnitOutlined />}
            label='Post Product To'
            disabled={disabledPostProductTo}
          />
        }
        disabled={disabledPostProductTo}
      >
        <Menu.Item
          key='post-product-to-walmart'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <Can I={ABILITY_ACTION.POST} a={ABILITY_SUBJECT.WALMART} passThrough>
            <RibbonButton
              size='small'
              className='button-item-dropdown'
              icon={<ShopOutlined />}
              label={'Walmart'}
              onClick={togglePostToModal}
              disabled={disabledPostToWalmart}
            />
          </Can>
        </Menu.Item>

        {/* <Menu.Item
          key='post-product-to-kroger'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <RibbonButton
            size='small'
            className='button-item-dropdown'
            icon={<ShopOutlined />}
            label={'Kroger'}
            disabled={true}
          />
        </Menu.Item> */}
      </SubMenu>
    </>
  );
};

export default PostToRibbonSection;
